import { type ComponentProps, type ReactNode } from "react";
import { Dialog, DialogContent, DialogTrigger } from "@tellescope/ui";
import { EventFormDialogContents } from "./EventFormDialogContent/EventFormDialogContents";
import type { EventFormInitialValues } from "../../../hooks";

export interface EventCreateDialogProps extends Omit<ComponentProps<typeof Dialog>, "children"> {
  children?: ReactNode;
  timezone?: string;
  onSuccess?: () => void;
  initialFormValues?: EventFormInitialValues;
}

export const EventCreateDialog = ({
  children,
  timezone,
  onSuccess,
  initialFormValues,
  ...rest
}: EventCreateDialogProps) => {
  return (
    <Dialog {...rest}>
      {!!children && <DialogTrigger>{children}</DialogTrigger>}
      <DialogContent
        data-testid="event-create-dialog"
        showCloseButton={false}
        divided
        overlayVariant="light"
        className="font-light transition-all overflow-hidden max-h-[90svh] flex flex-col"
      >
        <EventFormDialogContents
          onSuccess={() => {
            onSuccess?.();
          }}
          onCancel={() => rest.onOpenChange?.(false)}
          timezone={timezone}
          initialFormValues={initialFormValues}
        />
      </DialogContent>
    </Dialog>
  );
};
